var map = {
	"./no/handelsbanken.png": 44375,
	"./no/melhusbanken.png": 25942,
	"./no/naeringsbanken.png": 15877,
	"./no/sbanken.png": 18519,
	"./no/spareskillingsbanken.png": 67951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77424;